import axios from 'axios';
import { debounce } from 'lodash';
import { getTimeSince } from './helpers';

class BrixInstagramFeed {
  static init(...parameters) {
    return new BrixInstagramFeed(...parameters);
  }

  constructor(block) {
    this.content = block.querySelector('.content');

    if (this.content) {
      this.restUrl = this.content.querySelector('.instagram-feed').dataset.restUrl;
      this.instagramAccount = this.content.querySelector('.instagram-feed').dataset.instagramAccount;
      this.imageBoxes = this.content.querySelectorAll('.image-box');
      this.imageElements = this.content.querySelectorAll('.image-box img');
      this.imageLinks = this.content.querySelectorAll('.image-link');
      this.bottomLinks = this.content.querySelectorAll('.bottom-link');

      if (this.restUrl) {
        this.fetchFeed();
      }

      window.addEventListener('resize', debounce(() => {
        if (this.images) {
          this.insertFeedImages();
        } else {
          this.insertFallbackImages();
        }
      }), 300);
    }
  }

  insertFeedImages() {
    if (this.images && this.imageElements.length > 0) {
      [...this.imageElements].forEach((imageElement, index) => {
        const imageBox = this.imageBoxes[index];
        const imageData = this.images[index];
        const imageLink = this.imageLinks[index];
        const bottomLink = this.bottomLinks[index];

        if (imageData && imageData.media_url) {
          if (window.innerWidth < 576 && index > 3) {
            imageBox.classList.add('-hidden');
            return;
          }

          if (imageElement.src !== imageData.media_url) {
            imageElement.setAttribute('src', imageData.media_url);

            if (imageLink) {
              imageLink.setAttribute('href', imageData.permalink);
              imageLink.setAttribute('target', '_blank');
            }

            if (bottomLink) {
              bottomLink.setAttribute('href', imageData.permalink);
              bottomLink.setAttribute('target', '_blank');
            }

            // const timeSincePosted = document.createElement('p');
            // timeSincePosted.innerText = getTimeSince(imageData.timestamp).replace('för ', '');
            // timeSincePosted.classList.add('time-since-posted');
            // imageBox.insertBefore(timeSincePosted, bottomLink);

            const caption = document.createElement('p');
            caption.innerText = imageData.caption;
            caption.classList.add('post-caption');
            imageBox.insertBefore(caption, bottomLink);

            setTimeout(() => {
              imageElement.classList.add('-visible');
            }, 100);
          }

          imageBox.classList.remove('-hidden');
        } else if (imageElement.dataset.fallbackImage) {
          if (imageElement.src === '') {
            imageElement.setAttribute('src', imageElement.dataset.fallbackImage);

            setTimeout(() => {
              imageElement.classList.add('-visible');
            }, 100);
          }
        }
      });
    }
  }

  insertFallbackImages() {
    if (this.imageElements.length > 0) {
      [...this.imageElements].forEach((imageElement, index) => {
        const imageBox = this.imageBoxes[index];
        const imageLink = this.imageLinks[index];
        const bottomLink = this.bottomLinks[index];


        if (imageElement.dataset.fallbackImage) {
          if (window.innerWidth < 576 && index > 3) {
            imageBox.classList.add('-hidden');
            return;
          }

          if (imageLink) {
            imageLink.classList.add('-hidden');
          }

          if (bottomLink) {
            bottomLink.classList.add('-hidden');
          }

          if (imageElement.src === '') {
            imageElement.setAttribute('src', imageElement.dataset.fallbackImage);
            // eslint-disable-next-line no-param-reassign
            imageBox.dataset.caption = imageElement.dataset.fallbackCaption;

            imageBox.classList.remove('-hidden');

            setTimeout(() => {
              imageElement.classList.add('-visible');
            }, 100);
          }
        }
      });
    }
  }

  fetchFeed() {
    axios.get(`${this.restUrl}brix/v1/instagram-token/${this.instagramAccount}`)
      .then((response) => {
        if (response.data.token) {
          axios.get(`https://graph.instagram.com/me/media?fields=media_url,caption,permalink,media_type,timestamp&access_token=${response.data.token}`)
            .then((res) => {
              if (res.data.data) {
                const filteredImages = res.data.data.filter(post => post.media_type !== 'VIDEO').slice(0, 4);
                this.images = filteredImages.slice(0, 4);

                this.insertFeedImages();
              } else {
                this.insertFallbackImages();
              }
            })
            .catch(() => {
              this.insertFallbackImages();
            });
        } else {
          this.insertFallbackImages();
        }
      })
      .catch(() => {
        this.insertFallbackImages();
      });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-instagram-feed', BrixInstagramFeed.init);
}
